const servicesData = [
  {
    id: "advisory-consulting",
    title: "Advisory & Consulting",
    shortDesc:
      "Strategic financial and business advisory services to help organizations make informed decisions and drive sustainable growth.",
    description:
      "We provide strategic financial and business advisory services designed to help organizations make informed decisions and drive sustainable growth. Our team works closely with you to understand your business model, identify opportunities, and address key challenges.\n\nFrom financial restructuring and cost optimization to risk management and performance improvement, we deliver tailored solutions that align with your long-term vision.",
    offerings: [
      "Business strategy & financial planning",
      "Cost optimization & profitability improvement",
      "Risk assessment & mitigation",
      "Process improvement & operational efficiency",
    ],
    cta: "Schedule a Strategy Consultation",
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
  },
  {
    id: "virtual-cfo",
    title: "Virtual CFO",
    shortDesc:
      "Access experienced financial leadership without the cost of a full-time CFO. We act as your strategic finance partner.",
    description:
      "Our Virtual CFO services give you access to experienced financial leadership without the cost of a full-time CFO. We act as your strategic partner, helping you manage finances, improve reporting, and make data-driven decisions.\n\nWhether you're a growing startup or an established business, we ensure your financial operations are structured, compliant, and scalable.",
    offerings: [
      "Financial planning & forecasting",
      "MIS reporting & dashboards",
      "Cash flow management",
      "Budgeting & variance analysis",
      "Investor reporting",
    ],
    cta: "Get Your Virtual CFO Today",
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    id: "ecommerce-digital",
    title: "E-Commerce & Digital",
    shortDesc:
      "Navigate financial complexities and scale efficiently with solutions tailored for e-commerce and D2C businesses.",
    description:
      "We help digital-first businesses navigate financial complexities and scale efficiently. Our solutions are tailored for e-commerce brands, D2C startups, and online platforms looking to optimize margins and streamline operations.\n\nFrom revenue tracking to platform-wise profitability, we ensure you have clear financial visibility at every stage.",
    offerings: [
      "Platform-wise profitability analysis",
      "Inventory & cost management",
      "Payment gateway reconciliation",
      "Tax & compliance support",
      "Growth and scaling strategies",
    ],
    cta: "Optimize Your Digital Business",
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z" />
      </svg>
    ),
  },
  {
    id: "ipo-advisory",
    title: "IPO Advisory",
    shortDesc:
      "We guide you through every step of going public — from readiness assessment to a successful listing.",
    description:
      "Going public is a major milestone—and we guide you through every step of the journey. Our IPO advisory services ensure you are financially prepared, compliant, and positioned for a successful listing.\n\nWe work alongside your legal and investment teams to streamline processes and reduce risks.",
    offerings: [
      "IPO readiness assessment",
      "Financial restructuring & reporting",
      "Regulatory compliance support",
      "Documentation & due diligence",
      "Coordination with stakeholders",
    ],
    cta: "Start Your IPO Journey",
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
      </svg>
    ),
  },
  {
    id: "esg-sustainability",
    title: "ESG & Sustainability",
    shortDesc:
      "Integrate Environmental, Social & Governance principles into your strategy for long-term value creation.",
    description:
      "We help businesses integrate Environmental, Social, and Governance (ESG) principles into their core strategy. Our approach focuses on creating long-term value while ensuring compliance with evolving regulations and stakeholder expectations.\n\nBuild a responsible, future-ready business with our sustainability-driven solutions.",
    offerings: [
      "ESG strategy development",
      "Sustainability reporting",
      "Compliance & regulatory guidance",
      "Risk assessment & impact analysis",
      "ESG performance tracking",
    ],
    cta: "Build a Sustainable Future",
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    id: "startup-advisory",
    title: "Startup Advisory",
    shortDesc:
      "From idea to scale — we provide financial clarity and strategic direction for confident growth.",
    description:
      "We partner with startups from idea to scale, providing the financial clarity and strategic direction needed to grow confidently. Our goal is to help founders make smarter decisions and avoid costly mistakes.\n\nWhether you're raising funds or managing burn rate, we support you at every stage.",
    offerings: [
      "Financial modeling & projections",
      "Fundraising support & investor readiness",
      "Business structuring",
      "Cash flow & burn rate management",
      "Growth strategy & scaling support",
    ],
    cta: "Launch & Scale with Confidence",
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
  },
];

export default servicesData;
